import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { GabProvider } from './components/gab/GabComponents';
import { Notifications } from './lib/notifications';
import App from './App';
import './styles/app.css';
import './lib/notifyDefaults';

// Register service worker for offline support (production only — SW breaks HMR in dev)
if ('serviceWorker' in navigator && !import.meta.env.DEV) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      reg.update();
      // Flush queued writes when back online
      window.addEventListener('online', () => {
        reg.active?.postMessage({ type: 'flush-queue' });
      });
      // Request current queue size so OfflineIndicator shows accurate count on load
      navigator.serviceWorker.ready.then(() => {
        reg.active?.postMessage({ type: 'get-queue-size' });
      });
    }).catch(() => {});
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <GabProvider>
      <Notifications position="top-right" limit={5} zIndex={9999} />
      <App />
    </GabProvider>
  </StrictMode>,
);
